import React, { useEffect, useState, useContext } from 'react'
import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import DataTable from 'react-data-table-component'
import { Formik, Form, Field } from 'formik'
import CustomLoader from '../../layouts/CustomLoader'
import CardProduct from './CardProduct'
import AuthContext from '../../../middlewares/AuthContext'
import { useTranslation } from 'react-i18next'
import usePaginationComponentOptions from '../../layouts/paginationComponentOptions'
import Swal from 'sweetalert2'

const url = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_URL
  : process.env.REACT_APP_URL_DEV

const BRAND = '#6eb446'

interface AuthCtx {
  getHeaders: () => Promise<Record<string, string>>
}

interface Product { id: number; [key: string]: any }

const RestoreProduct: React.FC = () => {
  const { getHeaders }  = useContext(AuthContext) as AuthCtx
  const { t }           = useTranslation()
  const paginationComponentOptions = usePaginationComponentOptions()

  const [products, setProducts] = useState<Product[]>([])
  const [loading, setLoading]   = useState(false)
  const [totalRows, setTotalRows] = useState(0)
  const [perPage, setPerPage]   = useState(10)
  const [search, setSearch]     = useState('')

  const fetchTrash = async (page: number, perPageVal = perPage, searchVal = search) => {
    setLoading(true)
    try {
      const headers = await getHeaders()
      const res     = await axios.get<{ message: Product[]; total: number }>(
        `${url}products/trash?page=${page}&per_page=${perPageVal}&search=${searchVal}`,
        { headers }
      )
      setProducts(res.data.message)
      setTotalRows(res.data.total)
    } catch (err: any) {
      Swal.fire({ icon: 'error', title: err?.response?.data?.response || 'Error' })
    } finally {
      setLoading(false)
    }
  }

  const handlePageChange    = (page: number) => fetchTrash(page)
  const handlePerRowsChange = (newPerPage: number, page: number) => {
    setPerPage(newPerPage)
    fetchTrash(page, newPerPage)
  }

  const handleSearch = (values: { search: string }) => {
    setSearch(values.search)
    fetchTrash(1, perPage, values.search)
  }

  useEffect(() => { fetchTrash(1) }, [])

  const columns = [
    {
      name: t('products.products'),
      cell: (row: Product, index: number) => (
        <CardProduct product={row as any} i={index} url={url} setProducts={setProducts as any} />
      ),
    },
  ]

  return (
    <div className="row align-items-center">
      <div className="col-sm-8 col-md-8 col-lg-10 mb-3">
        <Formik initialValues={{ search }} onSubmit={handleSearch} enableReinitialize>
          <Form>
            <div className="input-group">
              <Field
                type="text"
                className="form-control"
                placeholder={t('products.search')}
                name="search"
              />
              <button className="btn fw-bold" type="submit" style={{ backgroundColor: BRAND, color: '#fff', border: 'none' }}>
                <FontAwesomeIcon icon={faMagnifyingGlass} />
              </button>
            </div>
          </Form>
        </Formik>
      </div>

      <div className="col-md-12 mb-5">
        <div className="card card-shadow">
          <DataTable
            columns={columns}
            data={products}
            fixedHeader
            fixedHeaderScrollHeight="800px"
            progressPending={loading}
            pagination
            paginationPerPage={perPage}
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            paginationComponentOptions={paginationComponentOptions}
            paginationRowsPerPageOptions={[10, 20, 50, 100]}
            progressComponent={<CustomLoader />}
            dense
          />
        </div>
      </div>
    </div>
  )
}

export default RestoreProduct
